export enum InstanceActions {
    Start = 'start',
    Stop = 'stop',
    Restart = 'restart',
    Redeploy= 'redeploy'
}
